import { formatDateHuman, parseDateRaw } from "../date-utils";
export const transportDocumentDtoFields = [{
        name: "documentNumber",
        title: "Numero",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => record.transportDocument.yearlyNumber + record.transportDocument.phaseCode + '/' + record.transportDocument.year
    }, {
        name: "documentDate",
        title: "Data",
        titleClass: "has-text-centered",
        dataClass: "has-text-centered",
        render: (record) => formatDateHuman(parseDateRaw(record.transportDocument.documentDate))
    }, {
        name: "purposeDescription",
        title: "Scopo",
        render: (record) => record.purposeDescription
    }, {
        name: "customerName",
        title: "Provenienza",
        render: (record) => record.customerName
    }, {
        name: "destinationName",
        title: "Destinazione",
        render: (record) => record.destinationName
    }];
